import { OngletsDRF } from '@/features/api/extranet/dto/Demande/CXPI/OngletsDRF.ts'

export const OngletsCXPI = [...OngletsDRF, 'Salarie'] as const
export type OngletsCXPI = (typeof OngletsCXPI)[number]

export const OngletsCXPILibellés: Record<OngletsCXPI, string> = {
  Employeur: 'Employeur',
  Salarie: 'Salarié',
  Contrat: 'Contrat',
  Formation: 'Formation',
}
